import { render, staticRenderFns } from "./pre-redpacket-detail.vue?vue&type=template&id=47c1d783&"
import script from "./pre-redpacket-detail.vue?vue&type=script&lang=js&"
export * from "./pre-redpacket-detail.vue?vue&type=script&lang=js&"
import style0 from "./pre-redpacket-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports